import styled from 'styled-components'

// Utils
import { breakpoint } from 'utils'

// Icons
import { ReactComponent as BaseLockIcon } from 'icons/lock-16.svg'

// Components
import Panel from '../Panel'
import Button, { AsyncButton } from 'components/Button'
import Pill from 'components/Pill'

export const Lock = styled(BaseLockIcon)`
  margin: 0 2px 0 0; /* stylelint-disable-line scales/space */
  width: 16px;
  height: 16px;
  order: -1;
  opacity: 0.4;
  color: ${({ theme }) => theme.colors.text.dark.base};

  ${breakpoint('xs')`
    order: 0;
    margin: 0 0 0 2px;
  `}
`

export const StripeTransactionsWrapper = styled.aside`
  display: inline-flex;
  align-items: center;
  padding: 10px ${({ theme }) => theme.space[6]}px; /* stylelint-disable-line scales/space */
  width: 100%;
  font-size: ${({ theme }) => theme.fontSizes.tinier};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.dark.base};

  ${({ theme }) => breakpoint('xs')`
    width: auto;
    padding: 10px;
    border: none;

    position: absolute;
    right: 0px;
    top: 0px;

    font-size:  ${theme.fontSizes.tiny};
  `}
`

export const StripeTransactionsText = styled.span`
  white-space: pre-wrap;
  color: ${({ theme }) => theme.colors.text.dark.tertiary};
  font-size: ${({ theme }) => theme.fontSizes.tinier};

  ${({ theme }) => breakpoint('xs')`
    font-size: ${theme.fontSizes.tiny};
  `}
`

export const PaymentInformationWrapper = styled(Panel)`
  position: relative;
`
export const List = styled.ul`
  margin: 8px 0 0 0;
  padding: 0;
  list-style: none;
`

export const StyledButton = styled(Button)`
  margin-top: 0px;
`

export const StyledAsyncButton = styled(AsyncButton)`
  margin-top: 0px;
`

export const PaymentLogoWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const SCAWarningPill = styled(Pill)`
  margin-top: 4px;
`

export const CreditBalanceTextContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const CreditLogoAmountContainer = styled.div`
  display: flex;

  img {
    margin-right: 8px;
  }
`
